import React from "react";
import IdeaGenerationSettingsPopover from "./IdeaGenerationSettingsPopover";

/**
 * Shared header for the ideas section. Used in both empty and full states.
 * Left: section title (e.g. "Ideas" or "3 Ideas")
 * Right: gear icon + primary Generate Ideas button
 */
const IdeasSectionHeader = ({
  ideaCount,
  onGenerateIdeas,
  isGenerating,
  promotionValue,
  onPromotionChange,
  promptValue,
  onPromptChange,
  numIdeas,
  onNumIdeasChange,
  settingsOpen,
  onSettingsToggle,
  generateButtonLabel = "Generate Ideas",
  usePrimaryButton = true,
}) => {
  const title = ideaCount === 0
    ? "Script Ideas for this Pattern"
    : `${ideaCount} Script Idea${ideaCount === 1 ? "" : "s"} for this Pattern`;

  return (
    <div className="flex items-center justify-between gap-4 flex-wrap">
      <h4 className="text-base font-semibold text-theme-text">{title}</h4>
      <div className="flex items-center gap-2">
        <IdeaGenerationSettingsPopover
          promotionValue={promotionValue}
          onPromotionChange={onPromotionChange}
          promptValue={promptValue}
          onPromptChange={onPromptChange}
          numIdeas={numIdeas}
          onNumIdeasChange={onNumIdeasChange}
          isOpen={settingsOpen}
          onToggle={onSettingsToggle}
          position="down"
        />
        <button
          type="button"
          onClick={onGenerateIdeas}
          disabled={isGenerating}
          className={`px-5 py-2.5 rounded-lg text-sm font-semibold hover:opacity-85 disabled:opacity-50 whitespace-nowrap ${
            usePrimaryButton
              ? "bg-theme-primary text-theme-button"
              : "border border-theme-secondary bg-theme-main text-theme-text"
          }`}
        >
          {isGenerating ? "Generating..." : generateButtonLabel}
        </button>
      </div>
    </div>
  );
};

export default IdeasSectionHeader;
